import { Link } from 'react-router-dom';

export default function Datenschutz() {
  return (
    <main className="min-h-screen bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 xl:px-16 py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium mb-8 cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Zurück zur Startseite
          </Link>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-8">
            Datenschutzerklärung
          </h1>

          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                1. Datenschutz auf einen Blick
              </h2>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">Allgemeine Hinweise</h3>
              <p className="text-sm">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                2. Verantwortliche Stelle
              </h2>
              <p className="text-sm">
                Haus Dornumersiel<br />
                Musterstraße 1<br />
                26553 Dornumersiel<br />
                Deutschland<br />
                E-Mail: info@haus-dornumersiel.de<br />
                Telefon: +49 (0) 4933 / 12345
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                3. Datenerfassung auf dieser Website
              </h2>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">Kontaktformular</h3>
              <p className="text-sm">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>

              <h3 className="text-sm font-semibold text-foreground-800 mb-2 mt-4">Cookies</h3>
              <p className="text-sm">
                Unsere Internetseiten verwenden sogenannte „Cookies“. Cookies sind kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                4. Google Maps
              </h2>
              <p className="text-sm">
                Diese Seite nutzt über eine API den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                5. Ihre Rechte
              </h2>
              <p className="text-sm">
                Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                6. SSL- bzw. TLS-Verschlüsselung
              </h2>
              <p className="text-sm">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground-900 mb-3">
                7. Widerspruch gegen Werbe-Mails
              </h2>
              <p className="text-sm">
                Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}